export class Ramo {
  iN_cod_ramo: number;
  vC_descripcionramo: string;
  nM_ValorTope: number;

  constructor(iN_cod_ramo: number, vC_descripcionramo: string, nM_ValorTope: number) {
    this.iN_cod_ramo = iN_cod_ramo;
    this.vC_descripcionramo = vC_descripcionramo;
    this.nM_ValorTope = nM_ValorTope;
  }
}
